import React from 'react';
import styles from './Actions.module.scss';
import AcceptChangeSelect from '../AcceptChangeSelect/AcceptChangeSelect';
import { getTranslation } from '../../../utils/translation';

const Actions = props => {
    const { resetBetSlip } = props;

    const onClearClick = () => {
        resetBetSlip();
    };

    return (
        <div className={'flex m-b-2'}>
            <AcceptChangeSelect />
            <button className={styles.clearAllButton} onClick={onClearClick}>
                <i className='icon-trash' /> {getTranslation('betSlip.actions.clearAll')}
            </button>
        </div>
    );
};

export default Actions;
